import api from '../axios';
import type { EntitlementResolution } from '~/store/entitlements/interfaces';

export function getEntitlements() {
  return api.get<EntitlementResolution>('/v1/me/entitlements', {
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
    params: { t: Date.now() },
  });
}

export function reportFeatureUsage(slug: string) {
  return api.post<{ used: number; remaining: number | null }>(
    `/v1/me/feature-usage/${encodeURIComponent(slug)}`,
  );
}

export function redeemCoupon(code: string) {
  return api.post<{
    redemptionId: string;
    type: string;
    applied: boolean;
    subscription: {
      status: string;
      startedAt: string;
      renewsAt: string | null;
    } | null;
    message: string;
  }>('/v1/me/coupons/redeem', { code });
}
